module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Special thanks to Richard Allen, Polly Ayre, Stephen Bennett, A.J. Downing, Timothy Dwight, Ralph W. Emerson, Enhanced Computers, J.S. Crane, John Flanders, Sam W. Foss, Watson Glider, Starr King, R.J. McGinnis, Kathy Melanson, Arthur Page, Theodore Parker, John Spargo, Charles Robinson, William F. Robinson, Frederick Tudor, Patricia Welch and John G. Whittier.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 69
// module chunks = 0